import { Helmet } from "react-helmet-async";
import { APP_NAME, APP_PHONE, APP_URL } from "../constants";

export const TitleTag = ({ pageTitle }) => {
  const defaultDescription =
    `${APP_NAME} offers expert K9 and dog training services in Lagos, Nigeria. ` +
    `From puppy training to advanced obedience, our certified trainers help your dog become a well-behaved companion. ` +
    `Contact us at ${APP_PHONE} to schedule a consultation.`;

  const ogTitle = `${pageTitle} | ${APP_NAME} - Professional K9 & Dog Training in Lagos, Nigeria`;
  const ogDescription =
    `Transform your dog's behavior with ${APP_NAME}'s expert training programs. ` +
    `We specialize in obedience, agility, protection, and more. Call ${APP_PHONE} or visit ${APP_URL} to learn more.`;

  const keywords = `
    DWL, DWL K9, DWL Dog Training, Dog Whisperers Limited, Dog Whisperers Lagos, K9 training Lagos, 
    dog training Lagos, K9 training Nigeria, dog training Nigeria, professional dog training Lagos, 
    puppy training Lagos, dog behavior training Lagos, service dog training Lagos, therapy dog training Lagos, 
    police dog training Lagos, military dog training Lagos, agility dog training Lagos, protection dog training Lagos, 
    guard dog training Lagos, search and rescue dog training Lagos, off-leash dog training Lagos, crate training Lagos, 
    potty training Lagos, leash training Lagos, clicker training Lagos, positive reinforcement training Lagos, 
    dog aggression training Lagos, barking control Lagos, separation anxiety training Lagos, socialization training Lagos, 
    fearful dog training Lagos, reactive dog training Lagos, calm dog training Lagos, impulse control training Lagos, 
    German Shepherd training Lagos, Labrador Retriever training Lagos, Golden Retriever training Lagos, Pitbull training Lagos, 
    Rottweiler training Lagos, Belgian Malinois training Lagos, Siberian Husky training Lagos, Bulldog training Lagos, 
    Poodle training Lagos, small dog training Lagos, large dog training Lagos, dog training collars Lagos, 
    dog training treats Lagos, dog training clickers Lagos, dog training harnesses Lagos, dog training leashes Lagos, 
    dog training toys Lagos, dog training pads Lagos, remote dog training devices Lagos, best dog trainers in Lagos, 
    affordable dog training Lagos, in-home dog training Lagos, board and train programs Lagos, advanced obedience training Lagos, 
    competition dog training Lagos, trick training Lagos, scent detection training Lagos, tracking training Lagos, 
    heel training Lagos, recall training Lagos, stay command training Lagos, online dog training Lagos, 
    virtual dog training Lagos, dog training videos Lagos, dog training webinars Lagos, DIY dog training Lagos, 
    dog training certification Lagos, certified dog trainers Lagos, dog training schools Lagos, dog training blogs Lagos, 
    dog training resources Lagos, beginner dog training Lagos, advanced dog training Lagos, rescue dog training Lagos, 
    aggressive dog training Lagos, puppy training Lagos, summer dog training Lagos, winter dog training Lagos, 
    holiday dog training Lagos, travel dog training Lagos, bonding with dogs Lagos, building trust with dogs Lagos, 
    understanding dog behavior Lagos, communicating with dogs Lagos, human-dog relationship Lagos, stop dog biting Lagos, 
    stop dog jumping Lagos, stop dog chewing Lagos, stop dog digging Lagos, stop dog pulling Lagos, stop dog barking Lagos, 
    DWL K9 training Lagos, DWL dog training Lagos, DWL K9 Nigeria, DWL dog training Nigeria, Dog Whisperers Limited K9, 
    Dog Whisperers Limited dog training, Dog Whisperers Limited Lagos Nigeria, DWL certified dog trainers, 
    DWL professional K9 trainers, DWL K9 behavior experts, DWL dog training solutions, DWL K9 training programs, 
    DWL dog training classes, DWL K9 obedience courses, DWL puppy training Lagos, DWL guard dog training Lagos, 
    DWL protection dog training Lagos, DWL service dog training Lagos, DWL therapy dog training Lagos, 
    DWL police dog training Lagos, DWL military dog training Lagos, DWL search and rescue dog training Lagos, 
    DWL agility dog training Lagos, DWL off-leash training Lagos, DWL crate training Lagos, DWL potty training Lagos, 
    DWL leash training Lagos, DWL clicker training Lagos, DWL positive reinforcement training Lagos, DWL aggression training Lagos, 
    DWL barking control Lagos, DWL separation anxiety training Lagos, DWL socialization training Lagos, 
    DWL fearful dog training Lagos, DWL reactive dog training Lagos, DWL calm dog training Lagos, 
    DWL impulse control training Lagos, DWL German Shepherd training Lagos, DWL Labrador training Lagos, 
    DWL Golden Retriever training Lagos, DWL Pitbull training Lagos, DWL Rottweiler training Lagos, 
    DWL Belgian Malinois training Lagos, DWL Siberian Husky training Lagos, DWL Bulldog training Lagos, 
    DWL Poodle training Lagos, DWL small dog training Lagos, DWL large dog training Lagos, DWL advanced obedience training Lagos, 
    DWL competition training Lagos, DWL trick training Lagos, DWL scent detection training Lagos, DWL tracking training Lagos, 
    DWL heel training Lagos, DWL recall training Lagos, DWL stay command training Lagos, DWL online dog training Lagos, 
    DWL virtual dog training Lagos, DWL dog training videos Lagos, DWL dog training webinars Lagos, DWL DIY dog training Lagos, 
    DWL dog training certification Lagos, DWL dog training schools Lagos, DWL dog training blogs Lagos, 
    DWL dog training resources Lagos, DWL beginner dog training Lagos, DWL advanced dog training Lagos, 
    DWL rescue dog training Lagos, DWL aggressive dog training Lagos, DWL puppy training Lagos, DWL summer dog training Lagos, 
    DWL winter dog training Lagos, DWL holiday dog training Lagos, DWL travel dog training Lagos, DWL bonding with dogs Lagos, 
    DWL building trust with dogs Lagos, DWL understanding dog behavior Lagos, DWL communicating with dogs Lagos, 
    DWL human-dog relationship Lagos, DWL stop dog biting Lagos, DWL stop dog jumping Lagos, DWL stop dog chewing Lagos, 
    DWL stop dog digging Lagos, DWL stop dog pulling Lagos, DWL stop dog barking Lagos
  `;

  return (
    <Helmet>
      <title>{ogTitle}</title>
      <meta name="description" content={defaultDescription} />
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:url" content={APP_URL} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="/og-image.png" />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Striker Technologies" />
      <script type="application/ld+json">
        {`
          {
            "@context": "http://schema.org",
            "@type": "Organization",
            "url": "${APP_URL}",
            "name": "${APP_NAME}",
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "${APP_PHONE}",
              "contactType": "Customer service"
            }
          }
        `}
      </script>
    </Helmet>
  );
};
